import { EMPTY_FUNCTION } from '../../../../constants/common'
import { useLinkLikeClick } from '../../../../hooks'
import { isListViewTypeWithPreview } from '../../../../utils/listViewType'

export function useMultipleViewTypeListHandleClick({
  getProfileLink,
  getProfileLinkState = EMPTY_FUNCTION,
  listViewType,
  setActiveItem,
}) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  function handleClickRow(id, event) {
    if (isListViewTypeWithPreview(listViewType)) {
      setActiveItem(id)
    } else {
      handleClick({
        event,
        link: getProfileLink(id),
        state: getProfileLinkState(id),
      })
    }
  }

  function handleMouseDownRow(id, event) {
    handleMouseDown({ event, link: getProfileLink(id) })
  }

  return {
    handleClickRow,
    handleMouseDownRow,
  }
}
